import styled from 'styled-components';

// Styled components for message center
export const MessageCenterContainer = styled.div`
  margin: auto;
  padding: 1.5rem;
  background-color: #f9f9f9;
  min-height: 100vh;
`;

export const NavbarContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: white;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 10;
  margin: -1.5rem -1.5rem 1.5rem -1.5rem;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  color: #333;

  &:hover {
    background-color: #f3f4f6;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const NavbarTitle = styled.h1`
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
  flex: 1;
  text-align: center;
`;

export const Container = styled.div`
  margin: auto;
  background-color: #f9f9f9;
`;

export const Title = styled.h2`
  margin-top: 1rem;
  font-size: 1.5rem;
  color: #333;
`;

export const Greeting = styled.h1`
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const ContentContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const SearchContainer = styled.div`
  margin-bottom: 20px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  background-color: white;
  transition: border-color 0.2s ease-in-out;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const MessageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  margin-top: 20px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #2563eb;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;

  h3 {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px 0;
    color: #374151;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
`;
